import styled from 'styled-components';
export const ListWrapper = styled.div `
  display: flex;
  position: relative;
  margin: -12px 0;
  p {
    margin-left: 10px;
  }
`;
export const SelfieImageWrapper = styled.div `
  @media (min-width: 360px) {
    .csl-griditem {
      max-width: 50%;
      width: 50%;
    }
  }
`;
export const GoodImageWrapper = styled.div `
  img {
    border: ${({ theme }) => `1px solid ${theme.color_icon_success}`};
  }
`;
export const BadImageWrapper = styled.div `
  img {
    border: ${({ theme }) => `1px solid ${theme.color_input_border_critical}`};
  }
`;
export const WarningIconWrapper = styled.span `
  border-radius: 50%;

  span {
    background: red;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    margin-top: 2px;
    margin-right: 4px;

    svg {
      color: ${({ theme }) => theme.color_icon_inverse_default_1};
    }
  }
`;
//# sourceMappingURL=styles.js.map